module.exports = __webpack_public_path__ + "static/media/refrigerator-removal.1cc28b20.svg";